// src/pages/TherapistPage/CaseHistory/measuresApi.js
import api from '../../../services/api';

export const getNorms = () => api.get('/case-history/norms');
export const getScoreSheet = (caseId) => api.get(`/case-history/cases/${caseId}/score-sheet`);
export const analyseSession = (sessionId) =>
    api.post(`/case-history/capture-sessions/${sessionId}/analyse`);

export const saveDdkMeasures = (sessionId, task, body) =>
    api.put(`/case-history/capture-sessions/${sessionId}/ddk/${task}/measures`, body);
export const saveVoiceMeasures = (sampleId, body) =>
    api.put(`/case-history/voice-samples/${sampleId}/measures`, body);

export const listSessionWords = (sessionId) =>
    api.get(`/case-history/capture-sessions/${sessionId}/words`);
export const listSessions = (caseId) => api.get(`/case-history/cases/${caseId}/capture-sessions`);

// Annotation goes through the existing therapist-review endpoints, so a word
// checked here is checked everywhere — there is no second review state to drift.
export const saveWordReview = (progressId, body) => api.put(`/progress/${progressId}/review`, body);
export const decideWord = (progressId, status) =>
    api.post(`/progress/${progressId}/decision`, { status });

// Audio arrives as bytes from a private container, so it needs an object URL
// rather than a plain src.
export const fetchAudio = async (path) => {
    const response = await api.get(path, { responseType: 'blob' });
    return URL.createObjectURL(response.data);
};

export const ddkAudioPath = (taskId) => `/case-history/ddk-tasks/${taskId}/audio`;
export const voiceAudioPath = (sampleId) => `/case-history/voice-samples/${sampleId}/audio`;
export const wordAudioPath = (progressId) => `/progress/${progressId}/audio`;

export const TASK_LABEL = { pa: '/pa/', ta: '/ta/', ka: '/ka/', pataka: '/pa-ta-ka/' };
export const TASK_KIND = { pa: 'AMR', ta: 'AMR', ka: 'AMR', pataka: 'SMR' };

export const VERDICT_LABEL = {
    normal: 'Within range',
    slow: 'Below range',
    above: 'Above range',
    reduced: 'Reduced',
};

export const measuresError = (err, fallback = 'Something went wrong. Try again.') =>
    err?.response?.data?.detail || fallback;
